/**
 * @generated SignedSource<<41de59cb6bd0d83647d28ca954658991>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverview_widget$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "WidgetCalendarOverview_widget";
};
export type WidgetCalendarOverview_widget$key = {
  readonly " $data"?: WidgetCalendarOverview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverview_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetCalendarOverview_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "WidgetCalendarOverview",
  "abstractKey": null
};

(node as any).hash = "cfc0be701eca750d59e360873ed7f309";

export default node;
